import React, { useState } from 'react';

import WpButton from 'Wpds/components/button/WpButton';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';
import { WpRadioGroup, WpRadioInput } from 'Wpds/components/radio';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  isOpen: boolean;
  onToggle: Function;
  onSaveClick: Function;
};

function UpdateScheduleModal({ isOpen, onToggle, onSaveClick }: Props) {
  const [applyToAll, setApplyToAll] = useState(false);
  const { tr } = useTranslation();
  const handleSaveClick = () => onSaveClick(applyToAll);
  return (
    <WpModal isOpen={isOpen} size="sm" onToggle={() => onToggle()} dismissOnBackdrop={false}>
      <WpModalHeader>{tr('perform.meeting_item.update_schedule_modal.title')}</WpModalHeader>
      <WpModalBody>
        <b>{tr('perform.meeting_item.update_schedule_modal.section_has_schedule')}</b>
        <p />
        {tr('perform.meeting_item.update_schedule_modal.question')}
        <WpRadioGroup
          id="apply_to_all_topics_or_just_this_topic_input"
          label=""
          required
          defaultValue="apply_to_just_this_topic"
          onChange={value => setApplyToAll(value === 'apply_to_all_topics')}
        >
          <WpRadioInput
            id="apply_to_all_topics"
            label={tr('perform.meeting_item.update_schedule_modal.apply_to_all')}
            value="apply_to_all_topics"
          />
          <WpRadioInput
            id="apply_to_just_this_topic"
            label={tr('perform.meeting_item.update_schedule_modal.just_this_topic')}
            value="apply_to_just_this_topic"
          />
        </WpRadioGroup>
      </WpModalBody>
      <WpModalFooter>
        <WpButtonGroup>
          <WpButton variant="tertiary" onClick={() => onToggle()}>
            {tr('perform.meeting_item.update_schedule_modal.cancel')}
          </WpButton>
          <WpButton onClick={handleSaveClick}>{tr('perform.meeting_item.update_schedule_modal.save')}</WpButton>
        </WpButtonGroup>
      </WpModalFooter>
    </WpModal>
  );
}

export default UpdateScheduleModal;
